"use client";

import { useSearchParams } from "next/navigation";
import { useMemo } from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

type FilterCounterProps = {
  param: string;
  className?: string;
};
export const FilterCounter = ({ param, className }: FilterCounterProps) => {
  const searchParams = useSearchParams();

  const getCount = useMemo(() => {
    if (param === "price") {
      const priceFrom = searchParams.get("priceFrom");
      const priceTo = searchParams.get("priceTo");
      if (priceFrom && priceTo) {
        return 2;
      }

      if (priceFrom || priceTo) {
        return 1;
      }

      return 0;
    }

    return searchParams.get(param)?.split(",").length || 0;
  }, [param, searchParams]);

  return getCount !== 0 ? (
    <Badge
      className={cn(
        "flex h-6 w-6 items-center justify-center rounded-full bg-brand-green1-300 p-0 text-white",
        className,
      )}
      data-pw="filter-counter"
    >
      {getCount}
    </Badge>
  ) : null;
};
